import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useLanguage } from "@shared/contexts/LanguageContext";

const VISITOR_LANGUAGES = ["en", "tc", "sc"];

// A visitor must pick a language before any content page shows (2026-10-08):
// without one, remember where they were heading and send them to the
// language page, which brings them back here afterwards. Returns whether a
// language is set — content pages load (and record their view) only then, so
// a first scan counts once, not twice.
export default function useRequireLanguage() {
  const { language } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();
  const ready = VISITOR_LANGUAGES.includes(language);

  useEffect(() => {
    if (!ready) {
      localStorage.setItem(
        "redirectPath",
        location.pathname + location.search + location.hash,
      );
      navigate("/");
    }
  }, [ready, location, navigate]);

  return ready;
}
